import { IUIStrings } from "./IUIStrings";
import IT from "./it";
import EN from "./en";

export const getLocalizationStrings = (language) => {
  let messages: IUIStrings = undefined;
  
  switch (language) {
    case "it":
      messages = IT;
      break;
    default:
    case "en":
      messages = EN;
      break;
  }
  
  return messages;
};